<template>
  <div
    class="modal fade in"
    tabindex="-1"
    role="dialog"
    style="display: block; background: rgba(230, 230, 230, 0.8)"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content" v-async="loading">
        <div class="modal-header modal-info">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            v-on:click="hideModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">Alterar Valor da Recarga Automática</h4>
        </div>
        <div class="modal-body">
          <p class="bold-600 text-center no-margin">Valor da Recarga</p>
          <div class="box-plus-minus">
            <button
              class="inline bold btn-charge"
              type="button"
              name="button"
              @click="calculate(rechargeAlter.valueTotal - multiple)"
            >
              <i class="icon-minus"></i>
            </button>
            <input
              class="inline form-control bold"
              type="text"
              name=""
              :value="rechargeAlter.valueTotal | cents"
              readonly
            />
            <button
              class="inline bold btn-charge"
              type="button"
              name="button"
              @click="calculate(rechargeAlter.valueTotal + multiple)"
            >
              <i class="icon-plus"></i>
            </button>
          </div>
          <div class="row">
            <div class="recharge-open-tax">
              Taxa de Recarga:
              <p>{{ rechargeAlter.taxTotal | cents }}</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" @click="hideModal()">
            Cancelar
          </button>
          <button
            type="button"
            class="btn btn-success"
            data-dismiss="modal"
            @click="alterRechargeUnit()"
          >
            Confimar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contract from "../../../services/contracts";
import sales from "../../../services/sales";
import { EventBus } from "../../../event-bus";

export default {
  props: ["contract"],
  data() {
    return {
      rechargeAlter: {},
      recharge: undefined,
      loading: undefined,
    };
  },
  mounted() {
    this.calculateRecharge();
  },
  computed: {
    multiple() {
      return this.getMultipleRecharge();
    },
    planId() {
      return this.contract.plan.planId;
    },
  },
  methods: {
    hideModal() {
      this.rechargeAlter = this.recharge;
      this.$emit("closeModalRecharge", this.contract.contractId);
    },
    alterRechargeUnit() {
      this.contract.rechargeValue = this.rechargeAlter.valueTotal;
      this.loading = contract
        .updateContractValueRecharge(
          this.contract.contractId,
          this.rechargeAlter.valueTotal
        )
        .then((data) => {
          this.$emit(
            "closeModalRecharge",
            this.contract.contractId,
            this.recharge.valueTotal
          );
        });

      //Comentado pois o mesmo foi migrado para a V1
      // this.loading = contract
      //   .updateContract({
      //     contract: this.contract,
      //   })
      //   .then((response) => {
      //     if (response.data.status.code == 0) {
      //       this.recharge = this.rechargeAlter;
      //     }
      //     this.$emit(
      //       "closeModalRecharge",
      //       this.contract.contractId,
      //       this.recharge.valueTotal
      //     );
      //   });
    },
    calculate(qtd) {
      if (qtd < this.multiple) return;
      this.loading = sales
        .calculateRechargeRate({
          value: qtd,
          planId: this.planId,
          contractId: this.contract.contractId,
        })
        .then((result) => {
          this.rechargeAlter = result;
        });
    },
    calculateRecharge() {
      this.loading = sales
        .calculateRechargeRate({
          value: this.contract.rechargeValue,
          planId: this.planId,
          contractId: this.contract.contractId,
        })
        .then((result) => {
          this.recharge = result;
          this.rechargeAlter = this.recharge;
        })
        .catch((err) => {
          this.calculate(this.multiple);
        });
    },
  },
};
</script>
<style scoped lang="scss">
.box-plus-minus {
  text-align: center;
  .form-control {
    font-size: 1.4em;
    width: 200px;
    text-align: center;
    height: 40px;
    margin: 0px -6px;
  }
  .btn-charge {
    border: 2px solid #b5b5b5;
    padding: 10px;
    color: black;
    margin-top: 5px;
    i {
      font-size: 1.2em;
    }
  }
}
.btn-success {
  margin-left: 10px;
  .align-icon-right-white {
    right: -19px;
  }
}
.info-box-left {
  padding-left: 20%;
}
.label-detail {
  margin-right: 20px;
  text-align: right;
  width: 190px;
}
.alt-value .btn-back {
  margin-left: 10px;
  padding: 5px 24px;
  .align-icon-right {
    right: -18px;
  }
  &:hover,
  &:active {
    padding: 5px 24px;
  }
}
.track-order {
  vertical-align: bottom;
}
small {
  display: block;
  padding: 0px 10px;
}
.content-box {
  margin: 5px;
  h3,
  p {
    margin: 0;
  }
  & .background-solid {
    background-color: #f2f2f2;
  }
}
.delivery-box {
  width: 220px;
  display: inline-block;
  vertical-align: top;
  height: 100px;
}
.icon-check {
  vertical-align: baseline;
  margin: 0px 10px;
}
.info-check {
  display: inline-block;
}

.content-box.methods {
  .col-md-6 div {
    display: inline-block;
    padding: 0px 10px;
  }
  small {
    padding: 0px;
  }
  h5,
  p {
    margin: 0;
  }
  .credit-card {
    vertical-align: baseline;
  }
}

.cell-plate > div {
  line-height: 30px;
  margin: 5px;
}

.label-link {
  float: right;
  font-size: 0.8em;
  font-weight: 400;
}

.button-title {
  margin-top: 0px;
}

.recharge-open-tax {
  display: block;
  padding: 20px 5px 0;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 400px) {
  .box-plus-minus .inline.form-control.bold {
    width: 150px;
  }
}

@media screen and (max-width: 991px) {
  .info-box,
  .info-box-left {
    padding-left: 10px;
  }
  .label-detail {
    width: 100%;
    text-align: left;
  }
  .recharge {
    width: 95%;
  }
}

@media (min-width: 320px) {
  .btn-sm {
    padding: 5px !important;
  }
  .border-right-gray {
    border-right: 0px;
  }
  .request-status {
    text-align: left;
  }
  .icon-coin.align-icon-right-white {
    display: none;
  }
  .box-payment {
    .btn-back {
      padding: 9px;
    }
  }
}

@media (min-width: 370px) {
  .btn-sm {
    padding: 5px 25px !important;
  }
  .icon-coin.align-icon-right-white {
    display: block;
  }
  .box-payment {
    .btn-back {
      padding: 9px 50px 10px 40px;
    }
  }
}

@media (min-width: 530px) {
  .border-right-gray {
    border-right: 2px solid #f2f2f2;
  }
  .box-payment {
    position: relative;
    height: 42px;
    p {
      position: absolute;
      bottom: 0;
    }
  }
  .h-rule-side-yellow.payment {
    margin-top: 2px;
  }
}

@media (min-width: 992px) {
  .request-status {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// modal-change-automatic-value.vue?1d91a974